import { PathOptions } from "leaflet";

export const gasoduto_transporte_pe = (feature: any): PathOptions => {
  return {
    color: "#ff8c00",
    weight: 3,
    opacity: 1,
  };
};
